import { jsx } from "react/jsx-runtime";
import { useServiceDropdownOptions } from "../utils/use-service-dropdown-options.js";
import { DropdownFieldWUT } from "../../../ui/dropdown-field/dropdown-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ServiceDropdownWUT = (props) => {
  const fieldType = FIELD_TYPES.SERVICES_DROPDOWN;
  const { isLoading, options, isEmpty, onFocus } = useServiceDropdownOptions(props);
  if (!props.isEditor && isEmpty) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    DropdownFieldWUT,
    {
      ...props,
      onFocus,
      fieldType,
      options: isLoading ? [] : options,
      isLoading
    }
  );
};
export {
  ServiceDropdownWUT
};
//# sourceMappingURL=service-dropdown-wut.js.map
